export const filterBy = {
  PINNED_PORTS: 'PINNED_PORTS',
  PINNED_SHIPS: 'PINNED_SHIPS',
}
